<template>
  <div class="timeline-container">
    <div class="timeline">
      <div class="line" v-if="timelineData && timelineData.length > 0">
        <div v-for="(group, gIndex) in safeType" :key="gIndex" class="group-row">
          <div class="line-title">安全状态图</div>
          <div class="events-row">
            <div
              v-for="(item, iIndex) in group.items"
              :key="iIndex"
              class="event-bar"
              :class="`risk-${item.riskLevel}`"
              :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
              @mouseenter="showTip($event, item)"
              @mouseleave="hideTip">
              <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                {{ hidden }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="highRisk.length > 0" class="line-part">
          <div class="line-title">中高危隐患</div>
          <div v-for="(group, gIndex) in highRisk" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="misreport.length > 0"  class="line-part">
          <div class="line-title">{{ riskLevel.name(6) }}</div>
          <div v-for="(group, gIndex) in misreport" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="otherHidden.length > 0"  class="line-part">
          <div class="line-title">其他隐患</div>
          <div v-for="(group, gIndex) in otherHidden" :key="gIndex" class="group-row">
            <div class="group-label">{{ group.groupName }}</div>
            <div class="events-row">
              <div
                v-for="(item, iIndex) in group.items"
                :key="iIndex"
                class="event-bar"
                :class="`risk-${item.riskLevel}`"
                :style="{ position: 'absolute', marginLeft: timeLeft(item), width: timeWidth(item) }"
                @mouseenter="showTip($event, item)"
                @mouseleave="hideTip">
                <div v-for="(hidden, idx) in item.positions" :key="idx" class="position">
                  {{ hidden }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 底部时间刻度 -->
        <div class="scale-row">
          <div class="scale-label"></div>
          <div class="scale-line">
            <span
              v-for="(day, idx) in scaleTicks"
              :key="idx"
              class="scale-tick"
              :style="{ left: (idx / (scaleTicks.length-1) * 100) + '%' }">
              {{ day }}
            </span>
          </div>
        </div>
      </div>
      <div class="line" v-else></div>

      <!-- 跟随鼠标 tooltip -->
      <div
        v-if="tipVisible"
        class="tooltip"
        :style="{ top: tipY + 'px', left: tipX + 'px' }">
        <div style="display: flex; gap: 10px">
          <div>{{ tipContent.riskName }}</div>
          <div v-for="(item, index) in hiddenPosition" :key="index">
            {{ item }}
          </div>
        </div>
        <div>
          {{ tipStartDate }} - {{ tipEndDate }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { processTimelineData } from "@/scripts/timelineProcessor";
import riskLevel from "@/scripts/riskLevel";

export default {
  name: "TimeLine",
  props: {
    timelineData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      safeType: [],
      highRisk: [],
      misreport: [],
      otherHidden: [],
      tipVisible: false,
      tipX: 0,
      tipY: 0,
      tipContent: {},
      tipStartDate: '',
      tipEndDate: '',
      hiddenPosition:[],
      minDay: 0,
      maxDay: 0,
      daySpan: 0
    };
  },
  computed: {
    riskLevel() {
      return riskLevel
    },
    scaleTicks() {
      const list = [];
      const start = this.minDay;          // 时间戳
      const end   = this.maxDay;          // 时间戳
      const step  = 24 * 60 * 60 * 1000;  // 1 天
      for (let t = start; t <= end; t += step) {
        list.push(this.formatDate(new Date(t)));
      }
      return list;
    }
  },
  watch: {
    timelineData: {
      handler(newVal) {
        if (!newVal || !newVal.length) {
          this.safeType = [];
          this.highRisk = [];
          this.misreport = [];
          this.otherHidden = [];
          return;
        }
        // 1. 先按原逻辑分组
        const result = processTimelineData(newVal);
        this.safeType   = result.safeType;
        this.highRisk   = result.highRisk;
        this.misreport  = result.misreport;
        this.otherHidden = result.otherHidden;

        // 2. 再扫描所有 item 拿到最小、最大日期
        let min = Infinity, max = -Infinity;
        const scan = arr => arr.forEach(g => g.items.forEach(i => {
          const s = this.startOfDay(i.startDateTime);
          const e = this.startOfDay(i.endDateTime);
          if (s < min) min = s;
          if (e > max) max = e;
        }));
        scan(result.safeType);
        scan(result.highRisk);
        scan(result.misreport);
        scan(result.otherHidden);

        this.minDay = min;
        this.maxDay = max;
        this.daySpan = max - min;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    formatDate(d) {
      const m   = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${m}-${day}`;
    },
    timeLeft(item) {
      const start = new Date(item.startDateTime).getTime();
      return ((start - this.minDay) / this.daySpan * 100) + '%';
    },
    timeWidth(item) {
      const start = new Date(item.startDateTime).getTime();
      const end   = new Date(item.endDateTime).getTime();
      return ((end - start) / this.daySpan * 100) + '%';
    },
    showTip(e, item) {
      this.tipContent = item;
      this.tipVisible = true;
      this.hiddenPosition = this.tipContent.positions || [];

      // 使用正则判断，只保留 yyyy-MM-dd
      const dateRegex = /^\d{4}-\d{2}-\d{2}/;
      this.tipStartDate = (item.startDateTime.match(dateRegex) || [''])[0];
      this.tipEndDate   = (item.endDateTime.match(dateRegex)   || [''])[0];


      const move = (ev) => {
        this.tipX = ev.clientX + 12;
        this.tipY = ev.clientY + 12;
      };
      document.addEventListener('mousemove', move);
      e.target._moveHandler = move;
    },
    hideTip(e) {
      this.tipVisible = false;
      if (e.target._moveHandler) {
        document.removeEventListener('mousemove', e.target._moveHandler);
      }
    },
    startOfDay(dateStr){
      const d = new Date(dateStr);
      d.setHours(0, 0, 0, 0);
      return d.getTime();
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
.timeline-container {
  flex: 1;
  display: flex;
}

.timeline {
  flex: 1;
  min-width: 0;
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
}

.line {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding-right: 20px;
  box-sizing: border-box;
}

.line-part {
  padding: 2px 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  margin-top: 5px;
}

.nodata {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  color: rgba(0, 139, 7, 0.5);
  font-size: 30px !important;
}

.line-title {
  font-size: 16px;
  line-height: 18px;
  font-weight: bolder;
  width: 100px;
  text-align: left;
  font-family: OPPOSans-M, sans-serif;
}

.group-row {
  display: flex;
  align-items: center;
  padding: 5px 0;
}

.group-label {
  font-size: 14px;
  width: 100px;
  color: #666;
  flex-shrink: 0;
  text-align: right;
  padding-right: 10px;
  font-family: OPPOSans-M, sans-serif;
}

.events-row {
  position: relative;
  flex: 1;
  display: flex;
  height: 15px;
  box-sizing: border-box;
}

.event-bar {
  height: 100%;
  transition: all 0.2s;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 20px;
  position: relative;
}

/* 风险等级颜色 */
.event-bar.risk-1 {
  background: #00DAAE;
}

.event-bar.risk-2 {
  background: #378def;
}

.event-bar.risk-3 {
  background: #378def;
}

.event-bar.risk-4 {
  background: #ff7a45;
}

.event-bar.risk-5 {
  background: #ed0e20;
}

.event-bar.risk-6 {
  background: #6c6c6c;
}

.position{
  font-size: 12px;
  position: absolute;
  width: 100px;
  text-align: center;
  left: 50%;
  transform: translate(-50%,-100%);
}

.scale-row {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.scale-label {
  width: 100px;
  flex-shrink: 0;
}

.scale-line {
  flex: 1;
  position: relative;
  height: 15px;
  border-top: 1px solid #aaa;
}

.scale-tick {
  width: 4em;
  text-align: center;
  position: absolute;
  transform: translateX(-50%);
  font-size: 11px;
  color: #666;
  top: 4px;
}

.tooltip {
  position: fixed;
  padding: 6px 10px;
  background: rgba(0, 0, 0, 0.75);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  z-index: 9999;
  white-space: nowrap;
}
</style>
